/* Stories Grid — custom sort dropdown + clickable cards */
(function () {
  function initSection(bar) {
    const root = bar.closest('.stories') || document;
    const grid = root.querySelector('[data-stories-grid]');

    /* ---- Sort (native select, igual que el listado de productos) ---- */
    const sortSelect = bar.querySelector('[data-sort-select]');
    if (sortSelect && grid) {
      sortSelect.addEventListener('change', () => sortGrid(grid, sortSelect.value));
    }

    /* ---- Clickable cards ---- */
    if (grid) {
      grid.querySelectorAll('.story-card').forEach((card) => {
        const href = card.dataset.href;
        if (!href) return;
        card.addEventListener('click', (e) => {
          // Let real links behave normally
          if (e.target.closest('a')) return;
          window.location.href = href;
        });
      });
    }
  }

  function sortGrid(grid, mode) {
    const cards = Array.from(grid.querySelectorAll('.story-card'));
    cards.sort((a, b) => {
      switch (mode) {
        case 'date-asc':
          return (Number(a.dataset.date) || 0) - (Number(b.dataset.date) || 0);
        case 'alpha-asc':
          return (a.dataset.title || '').localeCompare(b.dataset.title || '', undefined, { sensitivity: 'base' });
        case 'alpha-desc':
          return (b.dataset.title || '').localeCompare(a.dataset.title || '', undefined, { sensitivity: 'base' });
        case 'date-desc':
        default:
          return (Number(b.dataset.date) || 0) - (Number(a.dataset.date) || 0);
      }
    });
    cards.forEach((c) => grid.appendChild(c));
  }

  function init() {
    document.querySelectorAll('[data-stories-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
